// ── User auth helpers ─────────────────────────────────────────────────────────

export const getUser = () => {
  try {
    const saved = localStorage.getItem('wsncode_user');
    return saved ? JSON.parse(saved) : null;
  } catch { return null; }
};

export const saveUser = (user) => {
  localStorage.setItem('wsncode_user', JSON.stringify(user));
};

export const removeUser = () => {
  localStorage.removeItem('wsncode_user');
};

export const getInitials = (name) => {
  if (!name) return 'U';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};